<!--  -->
<template>
    <div class="fundsFromDetails" ref="fundsFromDetails">
        <div class="navigation_menu">
            <img :src="require('@/common/images/special/navigation.png')" alt="">
            <span>当前位置:</span>
            <span @click="goIndex">首页 ></span>
            <span @click="goSpecialIndex">{{examcodenameList[examcodenameIndex].name}} ></span>
            <span>{{details.newstypekindname}}</span>
        </div>
        <p class="title">{{details.subject}}</p>
        <p class="date_ussuer">
            <span class="date">{{details.releasetime}}</span>
            <span class="issuer">{{details.authorname}}</span>
        </p>
        <div class="advertising" v-if="advertising.adurl">
            <img @click="openLink(advertising.clickurl)" :src="advertising.adurl" alt="">
        </div>
        <div class="content" v-html="details.content"></div>
    </div>
</template>

<script>
import {getQuestionBankTopicContentInfo} from 'api/special'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            details: {},
            params: {
                contentid: this.$route.query.contentid
            },
            examcodenameIndex: 0,
            examcodenameList: [
                {name: '基金从业', code: 'jjcy'}
            ],
            advertising: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.params.contentid) {
            this.getQuestionBankTopicContentInfo()
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        window.addEventListener('scroll', this.bodyScroll)
    },
    methods: {
        bodyScroll() {
            if (document.documentElement.scrollTop > 540) {
                if (document.documentElement.scrollHeight - document.documentElement.scrollTop - document.body.clientHeight <= 370) {
                    this.$parent.isAbsolute = true
                } else {
                    this.$parent.isAbsolute = false
                    this.$parent.isFixed = true
                }
            } else {
                this.$parent.isAbsolute = false
                this.$parent.isFixed = false
            }
        },
        goIndex() {
            this.$router.push({name: 'Index'})
        },
        goSpecialIndex() {
            if (this.examcodenameList[this.examcodenameIndex].code === 'jjcy') {
                this.$router.push({name: 'Jjcy'})
            }
        },
        getQuestionBankTopicContentInfo() {
            this.setLoading(true)
            getQuestionBankTopicContentInfo({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    this.details = res.data
                    this.examcodenameList.some((item, index) => {
                        if (this.details.examcode === item.code) {
                            this.examcodenameIndex = index
                            return true
                        }
                    })
                    document.title = `${this.details.subject}_2021基金从业资格考试_考点解读_在线课堂_鲸融网`
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        openLink(linkurl) {
            if(linkurl){
                window.open(linkurl)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .fundsFromDetails {
        .navigation_menu {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            img {
                width: 10px;
                height: 13px;
                margin-right: 4px;
            }
            span {
                font-size: 14px;
                color: #999999;
                margin-right: 4px;
                cursor: pointer;
            }
        }
        .title {
            font-size: 32px;
            font-weight: bold;
            line-height: 45px;
            margin-bottom: 15px;
        }
        .date_ussuer {
            text-align: right;
            font-size: 14px;
            color: #999999;
            margin-bottom: 20px;
            .date {
                margin-right: 10px;
            }
        }
        .advertising {
            margin-bottom: 20px;
            img {
                width: 770px;
                height: 80px;
            }
        }
        .content {
            min-height: 1328px;
            * {
                line-height: 30px;
                max-width: 100%;
            }
        }
    }
</style>